import { useState } from 'react';
import useSWR, { SWRConfiguration } from 'swr';
import { DEDUP_INTERVAL_AUTOCOMPLETE_SUGGESTION } from '../../constants/swr-config';
import { CustomFieldOption } from '../../model/types';
import { endUserPublicFetcher, fetcherWithToken } from '../../utils/fetchers';
import { nonNullishValue } from '../../utils/helpers';
import useSWRCacheKeys, { usePublicApiSWRCacheKeys } from '../useSWRCacheKeys';
import { AutocompleteResponseType } from './useAutocompleteSearch';

export default function useAutocompleteSuggestionsByFieldKey(
    fieldKey: string,
    needSuggestions: boolean,
    isPublic: boolean = false,
    config: SWRConfiguration = {}
) {
    const keys = useSWRCacheKeys(`/field-values/${fieldKey}/options`);
    const publicKeys = usePublicApiSWRCacheKeys(`/field-values/${fieldKey}/options`);
    const [isSuggestionRequested, setIsSuggestionRequested] = useState(false);

    const isKeyExists = nonNullishValue(keys) || nonNullishValue(publicKeys);
    const isAbleToMakeRequest = needSuggestions && isSuggestionRequested && isKeyExists;
    const { data, isLoading, mutate } = useSWR<AutocompleteResponseType<CustomFieldOption>>(
        isAbleToMakeRequest ? (isPublic ? publicKeys : keys) : null,
        isPublic ? endUserPublicFetcher : fetcherWithToken,
        { revalidateIfStale: true, dedupingInterval: DEDUP_INTERVAL_AUTOCOMPLETE_SUGGESTION, ...config }
    );

    return {
        data,
        isLoading,
        mutate,
        setIsSuggestionRequested
    };
}
